import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-71" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-72" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-73" data-mp="129h0hmovcycw">
          Generate <span className="text-grape" data-id="element-74" data-mp="saruar6c52ch">bulletproof</span> police reports in <span className="text-blush" data-id="element-75" data-mp="sd4b310cx6ny">seconds</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-76" data-mp="nbey3ftkqix8">
          The ultimate "End-of-Shift" solution to cut paperwork time by 80% with Attorney-Vetted AI Frameworks
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-77" data-mp="3j9u0yz9q1olt">
          <img src="https://cdn.magicpatterns.com/uploads/gJcPVVuGt6XPr1n9neHNYC/ChatGPT_Image_25_sept_2026,_15_10_37.webp" alt="The 100+ Tactical Report AI Prompts™ — 6-Volume Visual System + 4 Professional Bonuses" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" data-id="element-78" data-mp="3e8efj63mtg2w" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-79" data-mp="2vjg50xo0n5ly">
          THE 100+ TACTICAL REPORT AI PROMPTS™ — 6-Volume Visual System + 4 Professional Bonuses · The SIGMA SMART™ Method · ⭐ 4.9 (Over 500 Officers Satisfied) · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-80" data-mp="s2td3kfiu7p7">
          <CTAButton href="#pricing" data-id="element-81" data-mp="nbl2il2gggag">See the 100+ Tactical Report AI Prompts now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-82" data-mp="ic891hh2wayw">
            <span className="font-bold text-plum" data-id="element-83" data-mp="i9voqxnuloio">THE #1 AI COMMAND SYSTEM FOR 2026.</span> Designed for Patrol Officers,
            Detectives, Supervisors, and Law Enforcement Professionals who need precise, legally-sound,
            and rapid documentation.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-84" data-mp="162lzx4nxg3rw">
            Arrests · Crime Scenes · Use of Force · Search Warrants · Crisis Response · Intelligence
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-85" data-mp="x3h3c3vxekid">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-86" data-mp="3hr3ptq808136">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-87" data-mp="21amuh5blvkk8" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-88" data-mp="269r2hsmsnc8z">
            - Everything you need in one single vault -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-89" data-mp="2b2snmidlg810">
          🔥 Limited Time Offer · Price will return to $38 soon
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-90" data-mp="2p1jvhn1v4xgp">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-91" data-mp="2tyaeoj8ys96c" />
          25 officers are viewing this tactical kit right now
        </p>
      </div>
    </header>;
}